// export const API_URL = 'https://api.new-coins.app'
// export const API_URL = 'http://192.168.18.80:3005'
// export const API_URL = 'http://192.168.18.10:3001'
// export const API_URL = 'https://api.safedingo.com'
// export const API_URL = 'http://192.168.18.48:3000'
// export const API_URL = "https://waffleApi.shubhraagarwal.repl.co";
// export const API_URL_RAFFLE = "https://waffleApi.shubhraagarwal.repl.co";
// export const API_URL =
//   "http://ec2-34-222-88-208.us-west-2.compute.amazonaws.com:4000";
// export const API_URL_RAFFLE =
//   "http://ec2-34-222-88-208.us-west-2.compute.amazonaws.com:4000";
// export const API_URL_RAFFLE = "http://localhost:1337";
export const API_URL = "https://api.tyou.me";
export const API_URL_RAFFLE = "https://api.tyou.me";
